import React from 'react';

export enum TagVariant {
  INTERACTIVE = 'interactive',
  STATIC = 'static'
}

export enum TagType {
  TAG = 'tag',
  FILTER = 'filter'
}

export interface TagProps {
  id?: string;
  label: string;
  tagType: TagType;
  tagVariant: TagVariant;
  statusIndicator?: string;
  leadingIcon?: React.JSX.Element;
  onDelete?: (identifier?: string) => void;
}

export interface TagGroupProps {
  tags: TagProps[];
}
